import * as React from "react";
import { Cart, Dev } from "../../stores";
import { useLocation } from "wouter";
import { tryMustRedirect } from "./must-redirect";

type Props = { children?: React.ReactNode };

export function CartMain({ children }: Props): JSX.Element {
    const [location, setLocation] = useLocation();
    const redirection = tryMustRedirect(location, {
        allowCart: Dev.allow_cart,
        items: Cart.items,
        startedCheckout: Cart.startedCheckout,
        shippingCompleted: Cart.address.city !== "" && Cart.address.state !== "",
    });

    React.useEffect(() => {
        if (redirection.isSome()) {
            console.log("cart main is redirecting user to", redirection.get());
            setLocation(redirection.get(), { replace: true });
        } else {
            Cart.startCheckout();
        }
    }, [Cart.startedCheckout]);

    // # # #
    // TODO: Show time warning
    // # # #

    if (redirection.isSome()) {
        return <React.Fragment />;
    }

    return (
        <section className="padder">
            <section id="cart" className="pure-g center-children">
                <div className="pure-u-1-1 pure-u-lg-20-24">{children}</div>
            </section>
        </section>
    );
}
